import './App.css';
import Home from './components/Home/Home';
import About from './components/AboutMe/About';
import Resume from './components/Resume/Resume';
import Project from './components/Project/Project';
import Contact from './components/ContactMe/Contact';

function App() {
  return (
    <div className="App">
      <Home/>
      <About/>
      <Resume/>
      <Project/>
      <Contact/>
    </div>
  );
}

export default App;
